export default __webpack_public_path__ + "static/media/money_Unlocked.9d012a62.png";